import { api } from "@/http/api-client"
import type { TAccountForm, TCreateAccountResponse } from "./types"

export function createAccount(params: TAccountForm) {
  const { initialBalance, ...payload } = params
  return api.post<TCreateAccountResponse>("/finances/accounts", {
    json: {
      ...payload,
      ...(initialBalance && { initialBalance }),
    },
  })
}
